export const spaces = {
  margin: {
    xs: "0.25em",
    small: "0.4em",
    medium: "0.6em",
    base: "0.8em",
    large: "1em",
    big: "1.5em",
    xl: "2.0em",
    xxl: "2.5em",
    vertical: "3em",
    vertical_big: "4em",
    vertical_double: "8em",
    horizontal_small: "4em",
    horizontal: "6em",
  },
  padding: {
    xs: "0.25em",
    small: "0.4em",
    medium: "0.6em",
    base: "1em",
    large: "1.3em",
    big: "1.7em",
    xxl: "2em",
  },
};

//${({ theme }) => theme.spaces.padding.???};
//${({ theme }) => theme.spaces.margin.???};
